import * as tool from './tool'
import * as datetime from './datetime'
import * as dom from './dom'
import * as tree from './tree'
import * as array from './array'
import * as table from './table'
import Vue from 'vue'
const utils = {
  ...tool,
  ...datetime,
  ...dom,
  tree: {
    ...tree
  },
  array: {
    ...array
  },
  table: {
    ...table
  }
}

import Clipboard from 'clipboard'

function clipboardSuccess() {
  console.log('复制成功')
}
function clipboardError() {
  console.log('复制失败')
}

export const handleCopy = (text, event, onSuccess, onError) => {
  event = event || {}
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    onSuccess ? onSuccess() : clipboardSuccess()
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    onError ? onError() : clipboardError()
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.onClick(event)
}

/**
 * 函数防抖精简版
 * @param {Function} func 回调函数
 * @param {Number} timeout 时间
 */
let time = null
export function debounce(fun, t = 100) {
  if (time) clearTimeout(time)
  time = setTimeout(() => {
    fun()
  }, t)
}
// 获取url参数
export function getUrlParams(url) {
  url = url || location.hash
  console.log(url.split('?'))
  if (url.split('?').length == 1) return ''
  let urlStr = url.split('?')[1]
  let obj = {}
  let paramsArr = urlStr.split('&')
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    let arr = paramsArr[i].split('=')
    obj[arr[0]] = arr[1]
  }
  return obj
}

export const getHtml = (component, propsData = {}) => {
  // 利用Vue.extend扩展vue组件
  const comp = Vue.extend(component)
  // 此处实例化
  const domEl = new comp({
    el: document.createElement('div'),
    // store,
    // router,
    propsData
  })
  // domEl.show = true;
  return domEl.$el
}

// 递归转换所需要的数据
// 自定义添加数据格式 add-{添加的数据} 例如:{expand:'add-true'}
// config特殊属性currentIndex 为当前数组添加下标,需配合children使用
// option isAll 是否把所有属性添加进数组中
export function transitionData(data, config = {}, option = {}) {
  function list(arr) {
    if (!Array.isArray(arr)) return

    return arr.map((item, index) => {
      let obj = {}
      if (option.isAll) {
        obj = { ...item }
      }
      for (let i in config) {
        if (i == 'children') {
          if (item[config[i]] && item[config[i]].length > 0) obj[i] = list(item[config[i]])
        } else if (i == 'currentIndex') {
          obj[i] = index
        } else if (config[i].includes('add-')) {
          obj[i] = config[i].replace('add-', '')
        } else {
          obj[i] = item[config[i]]
        }
      }
      return obj
    })
  }
  return list(data)
}

// key 为要递归的键
export function transData(data, key, callback) {
  function list(arr) {
    if (!Array.isArray(arr)) return
    return arr.map((item) => {
      let obj = callback && callback(item)
      if ((item[key] || []).length > 0) {
        obj.children = list(item[key])
      }else{
        delete obj.children
      }
      return obj
    })
  }
  return list(data)
}

export default utils
